import { UserRole, UserPermissions } from './UserRoles'

export const getPermissions = (roles: String[]): UserPermissions => {
    if (roles.length === 0) {
        console.log('No roles provided, defaulting to no permissions')
    }

    let permissions: UserPermissions = {
        canAdjustQuantity: false,
        canViewEntryContext: false,
        canTriggerUKDivert: false,
        canTriggerDSLeftCW: false,
        canTriggerManualClearing: false,
        canViewFullLogging: false,
        canSimulateEvents: false,
        canViewPostGoLiveLogging: false,
        canViewBasicView: false
    }

    roles.forEach(role => {
        if (role === UserRole.CONSULTING_USER) {
            permissions = {
                ...permissions,
                canViewBasicView: true,
            }
        }
        if (role === UserRole.BUSINESS_KEY_USER) {
            permissions = {
                ...permissions,
                canAdjustQuantity: true,
                canViewEntryContext: true,
                canTriggerUKDivert: true,
                canTriggerDSLeftCW: true,
                canTriggerManualClearing: true,
                canViewBasicView: true
            }
        }
        if (role === UserRole.BUSINESS_DIVERT_KEY_USER) {
            permissions = {
                ...permissions,
                canTriggerUKDivert: true,
                canViewBasicView: true
            }
        }
        if (role === UserRole.BUSINESS_MANUAL_CLEARANCE_USER) {
            permissions = {
                ...permissions,
                canTriggerManualClearing: true,
                canViewBasicView: true
            }
        }
        if (role === UserRole.TECHNICAL_SUPPORT_USER) {
            permissions = {
                ...permissions,
                canAdjustQuantity: true,
                canViewEntryContext: true,
                canSimulateEvents: true,
                canViewFullLogging: true,
                canTriggerUKDivert: true,
                canTriggerDSLeftCW: true,
                canTriggerManualClearing: true,
                canViewPostGoLiveLogging: true,
                canViewBasicView: true
            }
        }
    })
    return permissions
}
